import Vue from 'vue'
import components from '../components'
import BaseContainer from '../components/container/base/Index.vue'
import 'lib-flexible/flexible'
import HttpService from '../services/HttpService'
import AuthService from '../services/AuthService'
import RouterService from '../services/RouterService'
import ExceptionService from '../services/ExceptionService'
import {RouteAuthRanges, CrypticTypes} from '../enum'

/**
 * 移动端框架
 * @class Mobile
 */
export default class Mobile{
	
	/**
	 * @constructor
	 * @param {Object} param
	 * @param {Object} config
	 */
	constructor(param, config = mobileConfig) {
		this.param = param
		this.el = param.el || '#app'
		this.vueInstance = null
		this.config = config
		
	    if(this.param){
			this.init()
		}
	}
	
	registApi(apis){
		console.log('regist api')
		const $api = {}, vueInstance = this.vueInstance
		for(let i = 0; i < apis.length; i ++){
			const api = apis[i]
			api.format(Vue.prototype.$http)
			Object.assign($api, {
				...api.apis
			})
		}
		Vue.prototype.$api = $api
		return this
	}
	
	async init(){
		this.initPlatform()
		this.initVueConfig()
		this.loadComponents()
		this.createRootVueInstance()
	}
	
	async initPlatform(){
		const {axios: config} = this.config
		const httpService = new HttpService(config)
		const authService = new AuthService(this.config)
		const routerService = new RouterService(this.param.router, this.config.router)
		new ExceptionService()
		Object.assign(Vue.prototype, {
			'$config': this.config,
			'$http': {
				get: httpService.get.bind(httpService),
				post: httpService.post.bind(httpService)
			},
			'$auth': authService,
			'$ready': routerService.readly.bind(routerService)
		})
		
		setTimeout(() => {
			authService.setVueInstance(this.vueInstance)
			httpService.setVueInstance(this.vueInstance)
			routerService.setVueInstance(this.vueInstance)
		}, 100)
	}
	
	ready(fn){
		console.log('ready!')
		const {ready} = this.config
		if(ready && typeof ready === 'function'){
			ready(this.vueInstance)
		}
		fn && fn()
	}
	
	loadComponents(){
		components && Object.keys(components).forEach(key => {
			const {name = '', ...other} = components[key]
			if(name){
				const componentName = ['db', ...name.replace(/_/g, '').split('-')].join('-')
				Vue.component(componentName, {name, ...other})
			}
		})
	}
	
	async createRootVueInstance(){
		const el = this.el		
		this.vueInstance = new Vue({
		  ...(this.param),
		  render: function (h) {return h(BaseContainer) }
		}).$mount(el)
	}
	
	use(param, options){
		Vue.use(param, options)
		return this
	}
	
	initVueConfig(){
		Vue.config.productionTip = false
	}
}

export const mobileConfig = {
	platform: {
		type: RouteAuthRanges.NORMAL,
		name: 'h5_test',
		cryptic: CrypticTypes.BASE64,
		loadingText: '天道经纪'
	},
	axios: {
		timeout: 3000,
		header: {},
		withCredentials: false,
		auth: {},
		helper: {
			//responseInterceptor: function(status, res){}
		}
	},
	router: {
	},
	token: {
		cacheKey: 'session_token'
	},
	wx: {
		appId: 'wx0b35a29b6d5719c0'
	},
	ready(){
		
	}
}